import { all, takeEvery, put, call, select } from 'redux-saga/effects'


export default function* rootSaga() {
  yield all([
  ])
}
